import './Section.styles.scss';

import PropTypes from 'prop-types';

import prepareClassNames from '../../utils/prepareClassNames';

/* Size prop accept following values: 'medium' 'smaller' 'smallest' */

const Section = ({ name = '', direction = '', size = '', additionalClasses = [], refItem, children }) => {
    const containerClassNames = [
        name ? `${name}__container` : null,
        'container',
        size ? `container--${size}` : null,
        'flex',
        direction === 'column' ? 'flex--column' : null,
        ...additionalClasses,
    ];
    const joinedContainerClassNames = prepareClassNames(containerClassNames);

    return (
        <section className={name ? name : null}>
            <div className={joinedContainerClassNames} ref={refItem}>
                {children}
            </div>
        </section>
    );
};

Section.propTypes = {
    name: PropTypes.string.isRequired,
    direction: PropTypes.string,
    size: PropTypes.string,
    additionalClasses: PropTypes.array,
    refItem: PropTypes.object,
};

export default Section;
